<template>
  <v-app>
    <transition name="wizard-progress-slide" mode="out-in" appear>
      <wizard-progress v-if="wizardOpen"></wizard-progress>
    </transition>
    <top-menu></top-menu>
    
    <v-content>
      
      <transition name="fade-up" mode="out-in" appear>
        <router-view ref="route"></router-view>
      </transition>

    </v-content>

    <transition name="fade" mode="out-in" appear>
      <v-toolbar style="top:unset; bottom: 0; background-color: transparent; pointer-events: none;" flat fixed v-if="wizardNavigator.show">

        <v-btn color="primary" :class="{'ml-5':$vuetify.breakpoint.smAndUp, 'ml-1':$vuetify.breakpoint.xsOnly}" style="pointer-events: auto;" :style="{'min-width':($vuetify.breakpoint.smAndUp ? '150px' : '0px')}" :disabled="wizardNavigator.prevDisabled" @click="wizardPrev()" v-if="showWizardPrev">
          <span v-if="$vuetify.breakpoint.smAndUp">Back</span>
          <span v-else><v-icon>fa-arrow-left</v-icon></span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="solid-grey" :class="{'ml-5':$vuetify.breakpoint.smAndUp, 'ml-1':$vuetify.breakpoint.xsOnly}" style="pointer-events: auto;" :style="{'min-width':($vuetify.breakpoint.smAndUp ? '150px' : '0px')}" :disabled="wizardNavigator.nextDisabled" @click="wizardNext()" v-if="showWizardNext">
          <span v-if="wizardNavigator.progressStep == 'lookbook'">
            <span v-if="!wizardNavigator.itemsRemaining">Checkout</span>
            <span v-else>
              Choose {{ wizardNavigator.itemsRemaining }} More Item{{ (wizardNavigator.itemsRemaining == 1 ? '' : 's') }}
            </span>
          </span>
          <span v-else>Next</span>
        </v-btn>
      
      </v-toolbar>
    </transition>

  </v-app>
</template>

<script>
import TopMenu from './components/menus/TopMenu';
import WizardProgress from './components/menus/WizardProgress';

export default {
  name: 'App',
  components: {
    'top-menu': TopMenu,
    'wizard-progress': WizardProgress
  },
  data () {
    return {
      loading: true
    }
  },
  watch: {
    isAuthorized: function(newVal, oldVal) {
      if(newVal) {
        this.$root.drift_api.widget.show();
        let user = this.$store.getters.user;
        drift.identify(user._id, { // XXX could be something like a GUID or other ID.
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          nickname: user.first_name + ' ' + user.last_name,
          birthday: user.birthday,
          phone: user.phone
        });
      } else {
        this.$root.drift_api.widget.hide();
      }
    }
  },
  mounted: function() {
    if(this.$route.query.ref) {
      this.$store.commit('setReferredBy', this.$route.query.ref);
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    isAuthorized: function() {
      return this.$store.getters.isAuthorized;
    },
    isLoading: function() {
      return this.$store.getters.isLoading;
    },
    wizardNavigator: function() {
      return this.$store.getters.wizardNavigator;
    },
    wizardOpen: function() {
      return (this.wizardNavigator.show && this.$vuetify.breakpoint.smAndUp);
    },
    showWizardPrev: function() {
      if(this.wizardNavigator.progressStep == 'checkout') return false;
      return true;
    },
    showWizardNext: function() {
      if(this.wizardNavigator.progressStep == 'checkout') return false;
      if(this.wizardNavigator.progressStep == 'lookbook' && !this.wizardNavigator.hasLookbook) return false;
      return true;
    }
  },
  methods: {
    wizardNext: function() {
      this.$refs.route.nextStep();
    },
    wizardPrev: function() {
      this.$refs.route.previousStep();
    }
  }
}
</script>

<style lang="scss">
  @import './assets/css/main.scss';

  iframe#drift-widget.drift-widget-welcome-online,
  iframe#drift-widget.drift-widget-welcome-away {
    bottom: 60px !important;
  }
</style>
